import { AfterContentChecked, Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "single-range",
  templateUrl: "./single-range.component.html",
  styleUrls: ["./single-range.component.scss"],
})
export class SingleRangeComponent implements OnInit, AfterContentChecked {
  left: number = 0;
  labels:any;
  @Input() value: number = 0;
  @Input() indicator: boolean = false;

  constructor() {
  }

  ngOnInit() {}

  ngAfterContentChecked(): void {
    this.left = (this.value / 200) * 100;
    if (this.indicator) {
      this.left = 100;
    }
  }
}
